import { ReactElement, useCallback } from 'react';

import DisplayError from '../../components/info/DisplayError';
import Loading from '../../components/info/Loading';
import { createFetchContext } from '../../providers/FetchContextFactory';
import {
  getIdentificationTypes,
  IdentificationType,
} from '../../api/requests/tuitionProcess';

export interface IdentificationTypesLoaderProps {
  children: (props: {
    data: IdentificationType[];
    refresh: () => Promise<void>;
  }) => ReactElement;
}

const { FetchProvider, FetchConsumer } = createFetchContext<
  undefined,
  IdentificationType[]
>();

export const IdentificationTypesLoaderConsumer = FetchConsumer;

export default function IdentificationTypesLoader({
  children,
}: IdentificationTypesLoaderProps) {
  const request = useCallback(async () => {
    const data = await getIdentificationTypes();
    return { data };
  }, []);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return <Loading insideCard />;
          }

          return children({
            data: data || [],
            refresh,
          });
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
